import { useEffect } from 'react';
import Navbar from './Components/NavBar/navbar.js';
import Intro from './Components/Intro/intro.js';
import About from './Components/About/about.js';
import Gallery from './Components/Gallery/gallery.js';
import Services from './Components/Work/services.js';
import Achievements from './Components/Achievements/achivements.js';
import Reviews from './Components/Reviews/reviews.js';
import Contact from './Components/Contact/contact.js';
import Footer from './Components/Footer/foooter.js';
import Whatsapp from './Components/Whatsapp/whatsapp.js';
import Welcome from './Components/Welcome/welcome.js';

function App() {

  useEffect(() => {
    document.title = "Shree Photos Films | Dhavan Gadiwala";
  }, []);

  return (
    <div className="App">
      <Welcome />
      <Navbar />
      <Whatsapp />
      <Intro />
      <About />
      <Gallery />
      <Services />
      <Achievements />
      <Reviews />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
